export default __webpack_public_path__ + "static/media/phcnJos.6ef271e2.svg";